<div class="flex flex-col h-full">
  <!-- 顶部标题栏 -->
  <div class="p-[16px] border-b-[0.5px] border-neutral-n5 shrink-0">
    <div class="text-[16px] font-medium">系统消息</div>
  </div>

  <div class="flex-1 min-h-0 overflow-y-auto px-[16px] py-[12px] space-y-[24px]" (scroll)="onScroll($event)">
    @for (group of notices | noticeDateGroup; track group.dayLabel) {
      <!-- 日期分割线 -->
      <div class="date-divider">{{ group.dayLabel }}</div>

      <!-- 该日期下的通知 -->
      @for (notice of group.notices; track notice.id) {
        <fl-notice [notice]="notice"></fl-notice>
      }
    } @empty {
      @if (!loading) {
        <div class="py-[40px] text-center text-neutral-n4">暂无系统消息</div>
      }
    }

    <!-- 底部加载状态 -->
    @if (loading) {
      <div class="py-[16px] flex justify-center">
        <nz-spin nzSize="small"></nz-spin>
      </div>
    }
  </div>
</div>
